import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { setLevelsCompleted, setScore, setLevel, setStartLevel, setOptions } from '../REDUX/actions';
import { setMode, setLoadingGame, setIntroduced } from '../REDUX/actions';
import { goToPage } from '../../HOME/REDUX/actions';
import { PRACTICE, COMPETE, OPTIONS_KEY } from '../const';
import { GAME_PAGE, GREEN, YELLOW } from '../../HOME/const';
import BackButton from '../COMPONENTS/BackButton';
import PracticeIcon from '../COMPONENTS/PracticeIcon';
import CompeteIcon from '../COMPONENTS/CompeteIcon';
import { Background } from '../COMPONENTS/Background';
import Logo from '../ASSETS/MindShapesLogo.png';
import { windowSize, dbget } from '../../HOME/utils';
import { getAppInfo } from '../../HOME/info';
import * as f from '../logic';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import _ from 'lodash';
import BmgButton from '../../HOME/COMPONENTS/BmgButton';

class StartPage extends Component {
  onResize = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);

    dbget(OPTIONS_KEY, options => this.props.setOptions(options));

    this.props.setLevel(1);
    this.props.setStartLevel(1);
    this.props.setScore(0, 0, 0);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  handleMode = mode => {
    this.props.setMode(mode);

    if (mode === PRACTICE) {
      this.props.goToPage(GAME_PAGE);
    } else {
      Promise.resolve().then(() => f.onCompete(this.props));
    }
  };

  render() {
    const { app } = this.props;

    if (!app) {
      return null;
    }

    const appName = getAppInfo(app).name;

    const { x, y } = windowSize();
    const width = Math.min(x, y) / 7;

    return (
      <div className="page-root">
        <div className="ms-logo-title">
          <img src={Logo} width={width} alt="Mind Shapes logo" />
          <span className="ms-title" style={{ color: 'black', transform: 'translate(0.05em, 0.05em)' }}>
            {appName}
          </span>
          <span className="ms-title ms-title-gradient">{appName}</span>
        </div>
        <div className="ms-page" style={{ backgroundImage: Background }}>
          {_.map([PRACTICE, COMPETE], mode => {
            const color = mode === PRACTICE ? GREEN : YELLOW;
            return (
              <div
                key={mode}
                onClick={() => this.handleMode(mode)}
                className="app-option option"
                style={{ margin: '-5px', paddingLeft: '20px' }}>
                <span style={{ display: 'grid' }}>
                  <span style={{ gridArea: '1/1', transform: 'translate(0.05em, 0.05em)' }}>
                    {mode === PRACTICE ? <PracticeIcon width="60" color="black" /> : <CompeteIcon width="60" color="black" />}
                  </span>
                  <span style={{ gridArea: '1/1', zIndex: 1 }}>
                    {mode === PRACTICE ? <PracticeIcon width="60" /> : <CompeteIcon width="60" />}
                  </span>
                </span>
                <span style={{ color, fontSize: '22px', margin: '15px', fontWeight: 'bold' }}>{mode}</span>
              </div>
            );
          })}
          <BmgButton />
          <BackButton />
          <HomeButton />
        </div>
      </div>
    );
  }
}

function mapStateToProps({ ms, common }) {
  return { ...ms, ...common };
}

export default connect(
  mapStateToProps,
  {
    setMode,
    setLevel,
    setStartLevel,
    setLevelsCompleted,
    setScore,
    goToPage,
    setOptions,
    setLoadingGame,
    setIntroduced,
  }
)(StartPage);
